import React from 'react';
import styled from 'styled-components';

import Section from '../common/Section';
import WineriesList from '../common/Wineries';

const Wineries = () => (
  <StyledSection>
    <WineriesList />
  </StyledSection>
);

const StyledSection = styled(Section)`
  padding-top: 90px;
  padding-bottom: 60px;
  border-bottom: 1px solid rgb(220, 223, 232);
`;

export default Wineries;
